import React, {
    Component
} from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import snackbarContentCustomTypes from '../snackbar/SnackbarContentCustomTypes';
import AnnulerIcon from '@material-ui/icons/Undo';
import SaveIcon from '@material-ui/icons/SdStorage';
import EditIcon from '@material-ui/icons/Edit';
import PropTypes from 'prop-types';
import {
    withRouter
} from "react-router-dom";
import identity from '../../../services/Identity';
import readOnlyForm from '../../../services/ReadOnlyForm';



class BottomNavigationCustom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editMode: this.props.editMode || identity() == null
        }
    }

    handleSubmit = (event) => {
        var retour = false;
        if (this.props.currentContent.instance.ref != null) {
            retour = this.props.currentContent.instance.ref.handleSubmit(event);
        }
        if (retour) {
            this.props.snackBarRef.instance.handleOpen(snackbarContentCustomTypes.success.value, event);
        } else {
            this.props.snackBarRef.instance.handleOpen(snackbarContentCustomTypes.error.value, event);
        }
    }

    handleEdit = () => {
        this.setState({ editMode: true });
    }

    componentDidMount() {
        readOnlyForm(this.state.editMode || identity() == null);
    }

    componentDidUpdate() {
        readOnlyForm(this.state.editMode);
    }

    manageEditMode() {
        if (this.state.editMode) {
            return (<BottomNavigationAction label="Enregistrer" icon={<SaveIcon />} onClick={this.handleSubmit} />);
        } else {
            console.log("readOnly");
            return (<BottomNavigationAction label="Editer" icon={<EditIcon />} onClick={this.handleEdit} />);
        }
    }

    render() {
        return (
            <BottomNavigation
                showLabels
                className="bottomBarNav">
                <BottomNavigationAction label="Annuler" icon={<AnnulerIcon />} onClick={() => this.props.history.goBack()} />
                {this.manageEditMode()}
            </BottomNavigation>
        );
    }
}

BottomNavigationCustom.defaultProps = {
    editMode: false,
}

BottomNavigationCustom.propTypes = {
    snackBarRef: PropTypes.object.isRequired,
    currentContent: PropTypes.object.isRequired,
    editMode: PropTypes.bool,
};

export default withRouter(BottomNavigationCustom);


// WEBPACK FOOTER //
// ./src/components/custom/bottomNavigation/BottomNavigation.js